<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import RcdAvailable from "@/components/widgets/rcd-available.vue";
import RcdModal from "@/components/modals/rcd-modal.vue";
import RCDList from "@/components/widgets/rcd-list.vue";
import FinanceAttachments from "@/components/modals/finance-attachments.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import Swal from "sweetalert2";

export default {
    page: {
        title: "Reports of Collections & Deposits",
    },
    components: {
        Layout,
        PageHeader,
        RcdAvailable,
        RcdModal,
        RCDList,
        FinanceAttachments,
        PrintOptions,
    },
    data() {
        return {
            title: "Reports of Collections & Deposits",
            items: [
                {
                    text: "Dashboard",
                    href: "/",
                },
                {
                    text: "Reports of Collections & Deposits",
                    active: true,
                },
            ],
            tabIndex: 0,
            availableData: [],
            availableLoading: false,
            rcdData: [],
            selectedCollections: [],
            totalCollections: 0,
            tabModel: 0,
            rcdStatus: 'pending',
            rcdLoading: false,
        };
    },
    watch: {
        tabIndex: {
            async handler(newTabIndex) {
                if (newTabIndex == 0) {
                    this.availableLoading = true;
                    await this.getAvailableCollections(this.$store.state.data.selectedCampus.id);
                    this.availableLoading = false;
                } else if (newTabIndex == 1) {
                    this.rcdLoading = true;
                    await this.getRCD(this.rcdStatus, this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
                    this.rcdLoading = false;
                }
            }
        },
        tabModel: {
            async handler(newStatus) {
                this.rcdStatus = newStatus === 0 ? 'pending' : 'posted';
                this.rcdLoading = true;
                await this.getRCD(this.rcdStatus, this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
                this.rcdLoading = false;
            }
        }
    },
    async created() {
        this.availableLoading = true;
        await this.getAvailableCollections(this.$store.state.data.selectedCampus.id);
        this.availableLoading = false;
    },
    methods: {
        async changeData(cycle, campusId) {
            if(this.tabIndex === 0){
                this.availableLoading = true;
                await this.getAvailableCollections(campusId);
                this.availableLoading = false;
            }else if(this.tabIndex === 1){
                this.rcdLoading = true;
                await this.getRCD(this.rcdStatus, this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
                this.rcdLoading = false;
            }
        },
        async getAvailableCollections(campusId) {
            this.totalCollections = 0;
            try {
                const response = await this.$store.dispatch("rcd/GetAvailableRCD", campusId);
                const fundGroups = {};
                response.data.forEach(collection => {
                    const fundKey = collection.fundSourceId || 'No Fund Source';
                    if (!fundGroups[fundKey]) {
                    fundGroups[fundKey] = {
                        fundSourceId: collection.fundSourceId,
                        fundSource: collection.fundSource,
                        officers: {},
                        totalCollections: 0
                    };
                    }
                    
                    // Group by collecting officer within fund source
                    const officerKey = collection.collectingOfficerId;
                    if (!fundGroups[fundKey].officers[officerKey]) {
                    fundGroups[fundKey].officers[officerKey] = {
                        collectingOfficerId: collection.collectingOfficerId,
                        collectingOfficer: collection.collectingOfficer,
                        collections: [],
                        selectAll: false,
                        totalAmount: 0
                    };
                    }
                    const collectionWithSelection = {
                        ...collection,
                        selected: false
                    };
                    
                    fundGroups[fundKey].officers[officerKey].collections.push(collectionWithSelection);
                    fundGroups[fundKey].officers[officerKey].totalAmount += this.getCollectionTotal(collection);
                    fundGroups[fundKey].totalCollections++;
                    this.totalCollections++;
                });
                this.availableData = Object.keys(fundGroups).map(fundKey => ({
                    ...fundGroups[fundKey],
                    officers: Object.values(fundGroups[fundKey].officers),
                    selectAll: false
                }));
            } catch (error) {
                this.showToast("Error fetching available collections", "error");
            }
        },
        getCollectionTotal(collection) {
            return collection.collectionItems.reduce((total, item) => total + item.amount, 0);
        },
        async getRCD(status, cycle, campusId) {
            this.rcdData = [];
            if(status === 'pending'){
                await this.getPendingRCD(campusId, cycle);
            }else{
                await this.getPostedRCD(campusId, cycle);
            }
        },
        async getPendingRCD(campusId, cycle) {
            try {
                const response = await this.$store.dispatch("rcd/GetDraftRCD", { campusId, cycle });
                if(response.data.error){
                   return this.showToast(response.data.errorMessage, "error");
                }
                response.data.map(item => {
                    item.detailShow = true;
                    item.collectionShow = false;
                })
                this.rcdData = response.data;
            } catch (error) {
                this.showToast("Error fetching RCD data", "error");
                this.rcdData = [];
            }
        },
        async getPostedRCD(campusId, cycle) {
            try {
                const response = await this.$store.dispatch("rcd/GetPostedRCD", { campusId, cycle });
                if(response.data.error){
                   return this.showToast(response.data.errorMessage, "error");
                }
                this.rcdData = response.data;
            } catch (error) {
                this.showToast("Error fetching RCD data", "error");
                this.rcdData = [];
            }
        },
        
        onCollectionsSelected(selectedCollections) {
            this.$swal({
                title: 'Create RCD?',
                text: `Create Report of Collections & Deposits with ${selectedCollections.length} collections?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#556ee6',
                cancelButtonColor: '#f46a6a',
                confirmButtonText: 'Yes, create it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.selectedCollections = selectedCollections;
                    this.$refs.rcdModal.resetForm();
                    this.$bvModal.show('rcd-modal');
                }
            });
        },
        async onCreateRCD(modalData) {
            if(modalData.id > 0){
                await this.$store.dispatch("rcd/UpdateRCD", modalData).then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let index = this.rcdData.findIndex(x => x.id == modalData.id);
                    this.rcdData.splice(index, 1, modalData);
                    this.showToast("RCD updated successfully", "success");
                    this.$bvModal.hide('rcd-modal');
                }).catch(() => {
                    this.showToast("Error creating RCD", "error");
                }); 
            }else{
                await this.$store.dispatch("rcd/CreateRCD", modalData).then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.showToast("RCD created successfully", "success");
                    this.$bvModal.hide('rcd-modal');
                }).catch(() => {
                    this.showToast("Error creating RCD", "error");
                }); 
            }
        },
        async showAttachment(data) {
            this.$refs.finAttach.setUploadOpt({
                type: "RCD",
                placement: "left",
                folder: "Finance",
            });
            this.$refs.finAttach.getAttachments(data.att, data.id);
            this.$bvModal.show("finance-attachment-modal");
        },
        updateRCD(data) {
            this.$refs.rcdModal.updateData(data);
            this.selectedCollections = data.rcdDetails.map(d => {
                return {
                    ...d.collection,
                    orNumber: d.orNumber,
                    collectionId: d.collectionId,
                    totalAmount: d.totalAmount,
                }
            });
            this.$bvModal.show('rcd-modal');
        },
        deleteRCD(item) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                this.$store
                    .dispatch("rcd/RemoveRCD", item.id)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.rcdData.findIndex(x => x.id == item.id);
                        this.rcdData.splice(index, 1);
                        this.showToast('Successfully removed', "success");
                    })
                    .catch((err) => {
                        this.showToast('Something went wrong!', "error");
                    });
                }
            });
        },
        postRCD(item) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#28c76f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, post it!",
            }).then((result) => {
                if (result.value) {
                    this.$store.dispatch("rcd/PostRCD", item.id)
                    .then((res) => {
                        if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.rcdData.findIndex(x => x.id == item.id);
                        this.rcdData.splice(index, 1);
                        this.showToast('Successfully posted', "success");
                    }).catch((err) => {
                        this.showToast('Something went wrong!', "error");
                    });
                }
            });
        },
        printRCD(item) {
            this.$refs.printOpt.putOptions({
                apiUrl: 'api/Report/Finance/RCD', 
                routeVariables: [item.id]
            })
            this.$bvModal.show('print-options-modal')
        },
    }
};
</script>

<template>
    <Layout @changeCycle="changeData($event, $store.state.data.selectedCampus.id)" @changeCampus="changeData($store.state.data.cycle, $event)">
        <PageHeader :title="title" :items="items" />
        
        <div class="row">
            <div class="col-12">
                <div class="position-relative">
                    <b-tabs 
                        v-model="tabIndex" 
                        content-class="mt-3"
                        nav-class="nav-tabs-custom"
                    >
                        <!-- Available Collections Tab -->
                        <b-tab title="Available Collections" active>
                            <template #title>
                                <i class="bx bx-list-ul me-1"></i>
                                Available Collections
                            </template>
                            
                            <RcdAvailable 
                                :availableData="availableData"
                                :loading="availableLoading"
                                @collections-selected="onCollectionsSelected"
                            />
                        </b-tab>
                        
                        <!-- Reports of Collections & Deposits Tab -->
                        <b-tab title="Reports of Collections & Deposits">
                            <template #title>
                                <i class="bx bx-file me-1"></i>
                                Collections & Deposits
                            </template>
                            <b-tabs
                                v-model="tabModel"
                                pills
                                vertical
                                nav-class="p-0"
                                nav-wrapper-class="col-sm-2 border-end"
                                content-class="pt-0 px-2 text-muted"
                            >
                                <b-tab>
                                    <template v-slot:title>
                                        <i class="mdi mdi-file-document-edit me-1"></i>
                                        <span>Draft</span>
                                    </template>
                                    <RCDList 
                                        type="draft"
                                        :rcdData="rcdData"
                                        :loading="rcdLoading"
                                        @update="updateRCD"
                                        @delete="deleteRCD"
                                        @post="postRCD"
                                        @attachment="showAttachment"
                                        @print="printRCD"
                                    />
                                </b-tab>
                                <b-tab>
                                    <template v-slot:title>
                                        <i class="mdi mdi-file-check me-1"></i>
                                        <span>Posted</span>
                                    </template>
                                    <RCDList 
                                        type="posted"
                                        :rcdData="rcdData"
                                        :loading="rcdLoading"
                                        @print="printRCD"
                                    />
                                </b-tab>
                            </b-tabs>
                        </b-tab>
                    </b-tabs>
                    <!-- <div class="position-absolute rcd-report">
                        <b-dropdown
                            id="dropdown-dropleft"
                            right
                            variant="purple btn"
                            toggle-class="text-decoration-none"
                            menu-class="dropdown-menu"
                            no-caret
                        >
                            <template #button-content>
                                <i class="bx bx-printer me-1"></i>
                                Reports
                            </template>
                             <b-dropdown-item
                                @click="printWFP"
                                v-if="selectedOPCR && $store.state.data.selectedCampus.isExternal"
                            >
                                WFP
                            </b-dropdown-item>

                        </b-dropdown>
                    </div> -->
                </div>
            </div>
        </div>
        <RcdModal
            ref="rcdModal"
            :selectedCollections="selectedCollections"
            @submit="onCreateRCD"
        />
        <FinanceAttachments 
            ref="finAttach"
            :wActions="true"
        />
        <print-options ref="printOpt"></print-options>
    </Layout>
</template>

<style scoped>
.rcd-report{
    right: 0;
    top: 0;
}
.nav-tabs-custom .nav-link {
    border: none;
    border-bottom: 2px solid transparent;
    color: #74788d;
    font-weight: 500;
    padding: 12px 20px;
}

.nav-tabs-custom .nav-link.active {
    border-bottom-color: #556ee6;
    color: #556ee6;
    background: none;
}

.nav-tabs-custom .nav-link:hover {
    border-bottom-color: #556ee6;
    color: #556ee6;
}

.badge {
    font-size: 0.75rem;
}
</style>